export default __webpack_public_path__ + "static/bat-f9f3c9cce36c65ab992da75197486c1e.jpg";